import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const LanguageIcon = ({ color }: { color?: string }) => {
  const { token } = useToken();
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="GlobeSimple">
        <path
          id="Vector"
          d="M8 1.5C6.71442 1.5 5.45772 1.88122 4.3888 2.59545C3.31988 3.30968 2.48676 4.32484 1.99479 5.51256C1.50282 6.70028 1.37409 8.00721 1.6249 9.26809C1.8757 10.529 2.49477 11.6872 3.40381 12.5962C4.31285 13.5052 5.47104 14.1243 6.73192 14.3751C7.99279 14.6259 9.29973 14.4972 10.4874 14.0052C11.6752 13.5132 12.6903 12.6801 13.4046 11.6112C14.1188 10.5423 14.5 9.28558 14.5 8C14.498 6.2767 13.8126 4.62455 12.594 3.406C11.3754 2.18744 9.7233 1.50198 8 1.5ZM13.4763 7.5H10.9869C10.875 5.21813 9.99625 3.60438 9.27563 2.65C10.3945 2.9187 11.4013 3.53086 12.1548 4.40064C12.9082 5.27042 13.3705 6.3542 13.4769 7.5H13.4763ZM6.01438 8.5H9.98563C9.84125 11.1006 8.59625 12.6944 8 13.3125C7.40313 12.6938 6.15875 11.1 6.01438 8.5ZM6.01438 7.5C6.15875 4.89937 7.40375 3.30562 8 2.6875C8.59688 3.30813 9.84125 4.90188 9.98563 7.5H6.01438ZM6.72438 2.65C6.00375 3.60438 5.125 5.21813 5.01313 7.5H2.52313C2.6295 6.3542 3.09182 5.27042 3.84525 4.40064C4.59869 3.53086 5.60546 2.9187 6.72438 2.65ZM2.52313 8.5H5.01313C5.12688 10.7819 6.00375 12.3956 6.72438 13.35C5.60546 13.0813 4.59869 12.4691 3.84525 11.5994C3.09182 10.7296 2.6295 9.6458 2.52313 8.5ZM9.27313 13.35C9.99375 12.3956 10.8706 10.7819 10.9844 8.5H13.4744C13.3682 9.64547 12.9062 10.729 12.1533 11.5988C11.4003 12.4685 10.3941 13.0809 9.27563 13.35H9.27313Z"
          fill={color ?? token.colorText}
          fillOpacity="0.45"
        />
      </g>
    </svg>
  );
};

export default LanguageIcon;
